"use client";

import { useContext } from "react";
import { logEvent } from "@/service/logs/log";
import { ResourceContext } from "@/contexts/resource-context";
import Link from "next/link";
import { ArrowRightIcon, XIcon } from "lucide-react";
import { PictureAsset } from "@/components/common/picture-asset";
import { createPath } from "@/service/routing/routing";

export const HomeBannerBloodDonor = ({
  closeBanner,
}: {
  closeBanner: () => void;
}) => {
  const { logView } = useContext(ResourceContext);

  const handleRegisterClick = () => {
    logEvent("home_banner_button_click", logView, {
      banner_type: "blood_donor",
      banner_button_type: "register",
    });
  };

  return (
    <div className="relative my-10 w-full overflow-hidden rounded-2xl">
      <Link
        href={createPath("webinar.show", {
          slug: "jak-wspierac-tych-ktorzy-ratuja-innych-opieka-nad-honorowym-dawca-krwi-w-poz",
        })}
        onClick={handleRegisterClick}
        className="absolute inset-0 z-10 cursor-pointer"
        aria-label="Zapisz się na konferencję"
      />

      <PictureAsset
        source="https://cdn.remedium.md/image/common/2026/05/13/17/blood-donor-banner-bg-2x-png-6a0498349ba98"
        ext="png"
        alt="Tło baneru honorowy dawca krwi"
        className="absolute inset-0 hidden h-full w-full object-cover object-right md:block"
      ></PictureAsset>

      <PictureAsset
        source="https://cdn.remedium.md/image/common/2026/05/13/17/blood-donor-banner-bg-mobile-png-6a0496dc42a77"
        ext="png"
        alt="Tło baneru honorowy dawca krwi"
        className="absolute inset-0 h-full w-full object-cover object-center md:hidden"
      ></PictureAsset>

      <PictureAsset
        source="https://cdn.remedium.md/image/common/2026/05/13/17/blood-donnor-speaker-png-6a0496a0eee51"
        ext="png"
        alt="Ilustracja ludzi na banerze honorowy dawca krwi"
        className="absolute bottom-0 left-1/2 h-[55%] w-auto -translate-x-1/2 object-contain md:hidden"
      ></PictureAsset>

      <div className="absolute top-0 right-0 z-30 cursor-pointer p-4">
        <XIcon size={20} className="text-white" onClick={closeBanner} />
      </div>

      <div className="pointer-events-none relative z-20 flex flex-col items-center gap-5 px-6 pt-8 pb-72 text-center md:h-[200px] md:flex-row md:gap-10 md:px-0 md:py-0 md:pb-0 md:text-left">
        <div className="md:w-[44%] md:pl-10">
          <h2 className="text-2xl font-bold tracking-tight text-white sm:text-2xl md:text-3xl lg:text-5xl">
            Jak wspierać tych, którzy ratują innych?
          </h2>
          <p className="mt-2.5 text-sm text-white/90 md:text-xl">
            Opieka nad honorowym dawcą krwi w POZ
          </p>
        </div>

        <div className="relative z-30 flex flex-col items-center gap-3">
          <p className="text-xl font-bold text-white">
            14.05.2026 • godz. 18:00
          </p>
          <div className="flex items-center gap-2.5 rounded-full bg-white px-6 py-2.5 text-base font-semibold text-[#2c0000]">
            ZAPISZ SIĘ
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#e84b35] text-white">
              <ArrowRightIcon size={16} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
